import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-horiz-scroll',
    templateUrl: './horiz-scroll.component.html',
    styleUrls: ['./horiz-scroll.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HorizScrollComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
